import React from "react";
// import Logoo from "./images/logo.jpg"

const Header = () =>{
    return (
    <>
    <div className="header">
        {/* <img src={Logoo} alt = "logo" height="50" width="70"  /> */}
        <h1>Saki Keep</h1>
    </div>
    </>
    )
}

export default Header;